import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-autocomplete-multiselect',
  templateUrl: './autocomplete-multiselect.component.html',
  styleUrls: ['./autocomplete-multiselect.component.scss'],
})
export class AutocompleteMultiselectComponent  implements OnInit {
  @Input() items: any[] = [];
  @Input() selected: any[] = [];

  searchTerm = '';
  filteredItems: any[] = [];
  selectAllChecked = false;

  constructor(private popoverCtrl: PopoverController) {}

  ngOnInit() {
    this.filteredItems = [...this.items];
    this.updateSelectAllStatus();
  }

  filterItems() {
    const term = this.searchTerm.toLowerCase();
    this.filteredItems = this.items.filter(i =>
      i.name.toLowerCase().includes(term)
    );
  }

  isChecked(item: any): boolean {
    return this.selected.some(s => s.id === item.id);
  }

  toggleItem(item: any) {
    const index = this.selected.findIndex(s => s.id === item.id);
    if (index > -1) {
      this.selected.splice(index, 1);
    } else {
      this.selected.push(item);
    }

    this.updateSelectAllStatus();
  }

  toggleSelectAll() {
    if (this.selectAllChecked) {
      this.selected = [...this.items];
    } else {
      this.selected = [];
    }
  }

  updateSelectAllStatus() {
    this.selectAllChecked = this.selected.length === this.items.length;
  }

  closePopover() {
    this.popoverCtrl.dismiss(this.selected);
  }
}